// Multi-language content for Supera Leadership landing.
export const LANGS = [
  { code: "ES", label: "Español" },
  { code: "EN", label: "English" },
  { code: "PT", label: "Português" },
  { code: "FR", label: "Français" },
  { code: "IT", label: "Italiano" },
  { code: "DE", label: "Deutsch" },
  { code: "KO", label: "한국어" },
  { code: "AR", label: "العربية" },
];

export const translations = {
  ES: {
    kicker: "INTERNATIONAL LEADERSHIP SUPERA",
    heroPre: "Formamos a los",
    heroAccent: "líderes",
    heroPost: "que el mundo necesita.",
    heroSubtitle: "La plataforma internacional #1 en formación de liderazgo para niños, adolescentes y familias.",
    ctaStart: "Comenzar SUPERA",
    haveAccount: "Ya tengo cuenta ·",
    login: "Iniciar sesión",
    statLabels: ["Países", "Idiomas", "Líderes"],
    programsKicker: "NUESTROS PROGRAMAS",
    programsTitlePre: "Una ruta para cada",
    programsTitleAccent: "edad",
    programsTitlePost: "y momento.",
    enroll: "Inscribirme",
    whyKicker: "POR QUÉ SUPERA",
    whyTitlePre: "Liderazgo con",
    whyTitleAccent: "propósito",
    whyTitlePost: ".",
    values: [
      { title: "Propósito", text: "Cada niño descubre su brújula interna y aprende a guiar con intención." },
      { title: "Empatía", text: "Liderazgo que empieza escuchando, cuidando y colaborando con los demás." },
      { title: "Creatividad", text: "Retos, juegos y proyectos reales que despiertan ideas extraordinarias." },
      { title: "Mentalidad global", text: "Una comunidad internacional que aprende junta en varios idiomas." },
    ],
    methodKicker: "EL MÉTODO SUPERA",
    methodTitle: "Cuatro pasos para ser líder Supera en el mundo.",
    method: [
      { title: "Descubre tu ruta", text: "Elige el programa según tu edad y momento vital." },
      { title: "Vive los retos", text: "Misiones semanales, juegos y dinámicas que forman hábitos de líder." },
      { title: "Crece en comunidad", text: "Acompañamiento de mentores y familias en cada logro." },
      { title: "Impacta el mundo", text: "Proyectos con propósito que transforman tu entorno." },
    ],
    storiesPre: "Historias que",
    storiesAccent: "inspiran",
    storiesPost: ".",
    ctaFinalPre: "Tu hijo puede ser el",
    ctaFinalAccent: "líder",
    ctaFinalPost: "que el mundo necesita.",
    footerRights: "Supera Leadership · Formamos líderes en el mundo.",
    testimonials: [
      { name: "María G.", role: "Mamá · México", text: "Mi hija llegó tímida y hoy dirige su propio proyecto escolar. SUPERA cambió su vida." },
      { name: "Andrés P.", role: "Docente · Colombia", text: "La metodología es divertida y profunda a la vez. Los niños esperan cada sesión." },
      { name: "Lucía R.", role: "Supera High · España", text: "Aprendí a hablar en público y a liderar equipos. Me siento imparable." },
    ],
  },
  EN: {
    kicker: "INTERNATIONAL LEADERSHIP SUPERA",
    heroPre: "We shape the",
    heroAccent: "leaders",
    heroPost: "the world needs.",
    heroSubtitle: "The #1 international platform for leadership training for children, teens and families.",
    ctaStart: "Start SUPERA",
    haveAccount: "Already have an account ·",
    login: "Log in",
    statLabels: ["Countries", "Languages", "Leaders"],
    programsKicker: "OUR PROGRAMS",
    programsTitlePre: "A path for every",
    programsTitleAccent: "age",
    programsTitlePost: "and stage.",
    enroll: "Enroll",
    whyKicker: "WHY SUPERA",
    whyTitlePre: "Leadership with",
    whyTitleAccent: "purpose",
    whyTitlePost: ".",
    values: [
      { title: "Purpose", text: "Every child discovers their inner compass and learns to lead with intention." },
      { title: "Empathy", text: "Leadership that starts by listening, caring and collaborating with others." },
      { title: "Creativity", text: "Challenges, games and real projects that spark extraordinary ideas." },
      { title: "Global mindset", text: "An international community that learns together in several languages." },
    ],
    methodKicker: "THE SUPERA METHOD",
    methodTitle: "Four steps to become a Supera leader in the world.",
    method: [
      { title: "Discover your path", text: "Choose the program that fits your age and life stage." },
      { title: "Live the challenges", text: "Weekly missions, games and dynamics that build leadership habits." },
      { title: "Grow in community", text: "Guidance from mentors and families at every milestone." },
      { title: "Impact the world", text: "Purpose-driven projects that transform your environment." },
    ],
    storiesPre: "Stories that",
    storiesAccent: "inspire",
    storiesPost: ".",
    ctaFinalPre: "Your child can be the",
    ctaFinalAccent: "leader",
    ctaFinalPost: "the world needs.",
    footerRights: "Supera Leadership · Shaping leaders around the world.",
    testimonials: [
      { name: "María G.", role: "Mom · Mexico", text: "My daughter arrived shy and now leads her own school project. SUPERA changed her life." },
      { name: "Andrés P.", role: "Teacher · Colombia", text: "The methodology is fun and deep at once. The kids look forward to every session." },
      { name: "Lucía R.", role: "Supera High · Spain", text: "I learned to speak in public and lead teams. I feel unstoppable." },
    ],
  },
  PT: {
    kicker: "INTERNATIONAL LEADERSHIP SUPERA",
    heroPre: "Formamos os",
    heroAccent: "líderes",
    heroPost: "que o mundo precisa.",
    heroSubtitle: "A plataforma internacional #1 em formação de liderança para crianças, adolescentes e famílias.",
    ctaStart: "Começar SUPERA",
    haveAccount: "Já tenho conta ·",
    login: "Entrar",
    statLabels: ["Países", "Idiomas", "Líderes"],
    programsKicker: "NOSSOS PROGRAMAS",
    programsTitlePre: "Um caminho para cada",
    programsTitleAccent: "idade",
    programsTitlePost: "e momento.",
    enroll: "Inscrever-me",
    whyKicker: "POR QUE SUPERA",
    whyTitlePre: "Liderança com",
    whyTitleAccent: "propósito",
    whyTitlePost: ".",
    values: [
      { title: "Propósito", text: "Cada criança descobre sua bússola interna e aprende a guiar com intenção." },
      { title: "Empatia", text: "Liderança que começa ouvindo, cuidando e colaborando com os outros." },
      { title: "Criatividade", text: "Desafios, jogos e projetos reais que despertam ideias extraordinárias." },
      { title: "Mentalidade global", text: "Uma comunidade internacional que aprende junta em vários idiomas." },
    ],
    methodKicker: "O MÉTODO SUPERA",
    methodTitle: "Quatro passos para ser líder Supera no mundo.",
    method: [
      { title: "Descubra seu caminho", text: "Escolha o programa de acordo com sua idade e momento de vida." },
      { title: "Viva os desafios", text: "Missões semanais, jogos e dinâmicas que formam hábitos de líder." },
      { title: "Cresça em comunidade", text: "Acompanhamento de mentores e famílias em cada conquista." },
      { title: "Impacte o mundo", text: "Projetos com propósito que transformam o seu entorno." },
    ],
    storiesPre: "Histórias que",
    storiesAccent: "inspiram",
    storiesPost: ".",
    ctaFinalPre: "Seu filho pode ser o",
    ctaFinalAccent: "líder",
    ctaFinalPost: "que o mundo precisa.",
    footerRights: "Supera Leadership · Formando líderes no mundo.",
    testimonials: [
      { name: "María G.", role: "Mãe · México", text: "Minha filha chegou tímida e hoje lidera seu próprio projeto escolar. A SUPERA mudou sua vida." },
      { name: "Andrés P.", role: "Professor · Colômbia", text: "A metodologia é divertida e profunda ao mesmo tempo. As crianças esperam por cada sessão." },
      { name: "Lucía R.", role: "Supera High · Espanha", text: "Aprendi a falar em público e a liderar equipes. Sinto-me imparável." },
    ],
  },
  FR: {
    kicker: "INTERNATIONAL LEADERSHIP SUPERA",
    heroPre: "Nous formons les",
    heroAccent: "leaders",
    heroPost: "dont le monde a besoin.",
    heroSubtitle: "La plateforme internationale n°1 de formation au leadership pour enfants, adolescents et familles.",
    ctaStart: "Commencer SUPERA",
    haveAccount: "J'ai déjà un compte ·",
    login: "Se connecter",
    statLabels: ["Pays", "Langues", "Leaders"],
    programsKicker: "NOS PROGRAMMES",
    programsTitlePre: "Un parcours pour chaque",
    programsTitleAccent: "âge",
    programsTitlePost: "et étape.",
    enroll: "M'inscrire",
    whyKicker: "POURQUOI SUPERA",
    whyTitlePre: "Un leadership avec",
    whyTitleAccent: "un but",
    whyTitlePost: ".",
    values: [
      { title: "But", text: "Chaque enfant découvre sa boussole intérieure et apprend à guider avec intention." },
      { title: "Empathie", text: "Un leadership qui commence par écouter, prendre soin et collaborer." },
      { title: "Créativité", text: "Des défis, des jeux et des projets réels qui éveillent des idées extraordinaires." },
      { title: "Esprit global", text: "Une communauté internationale qui apprend ensemble en plusieurs langues." },
    ],
    methodKicker: "LA MÉTHODE SUPERA",
    methodTitle: "Quatre étapes pour devenir un leader Supera dans le monde.",
    method: [
      { title: "Découvre ton parcours", text: "Choisis le programme selon ton âge et ton moment de vie." },
      { title: "Vis les défis", text: "Des missions hebdomadaires et des jeux qui forment des habitudes de leader." },
      { title: "Grandis en communauté", text: "L'accompagnement de mentors et de familles à chaque réussite." },
      { title: "Impacte le monde", text: "Des projets porteurs de sens qui transforment ton environnement." },
    ],
    storiesPre: "Des histoires qui",
    storiesAccent: "inspirent",
    storiesPost: ".",
    ctaFinalPre: "Votre enfant peut être le",
    ctaFinalAccent: "leader",
    ctaFinalPost: "dont le monde a besoin.",
    footerRights: "Supera Leadership · Nous formons des leaders dans le monde.",
    testimonials: [
      { name: "María G.", role: "Maman · Mexique", text: "Ma fille est arrivée timide et dirige aujourd'hui son propre projet scolaire. SUPERA a changé sa vie." },
      { name: "Andrés P.", role: "Enseignant · Colombie", text: "La méthode est à la fois ludique et profonde. Les enfants attendent chaque séance." },
      { name: "Lucía R.", role: "Supera High · Espagne", text: "J'ai appris à parler en public et à diriger des équipes. Je me sens imparable." },
    ],
  },
};
